var map = {
	"./favicon-32x32.png": 75024,
	"./files_icon.png": 98194,
	"./logo.png": 66949,
	"./module.png": 46524,
	"./modules_icon.png": 90914,
	"./pumas-brand-footer.png": 44235,
	"./pumas-brand-header.png": 64519
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75675;